var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.18164,
    y: 0.904297,
    width: 2,
    height: 11,
    rx: 1,
    transform: "rotate(45 8.18164 0.904297)",
    fill: "#364863"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.18164,
    y: 0.904297,
    width: 2,
    height: 11,
    rx: 1,
    transform: "rotate(45 8.18164 0.904297)",
    fill: "#364863"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.18164,
    y: 0.904297,
    width: 2,
    height: 11,
    rx: 1,
    transform: "rotate(45 8.18164 0.904297)",
    fill: "#364863"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.404297,
    y: 2.31836,
    width: 2,
    height: 11,
    rx: 1,
    transform: "rotate(-45 0.404297 2.31836)",
    fill: "#364863"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.404297,
    y: 2.31836,
    width: 2,
    height: 11,
    rx: 1,
    transform: "rotate(-45 0.404297 2.31836)",
    fill: "#364863"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.404297,
    y: 2.31836,
    width: 2,
    height: 11,
    rx: 1,
    transform: "rotate(-45 0.404297 2.31836)",
    fill: "#364863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclude);
export default __webpack_public_path__ + "static/media/exclude.471bc9f861cd887ecbdda4288083e54c.svg";
export { ForwardRef as ReactComponent };